import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Home } from "lucide-react";
import siteLogo from "../assets/equitylogo.png";

const COUNTDOWN_SECONDS = 10;

export default function PaymentSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const txnId = searchParams.get("txnid");
    const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

    useEffect(() => {
        if (secondsLeft <= 0) {
            navigate("/");
            return;
        }

        const timer = setTimeout(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [secondsLeft, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#f7fbff] via-white to-[#f2fbf5] px-4">
            <div className="w-full max-w-md rounded-3xl border border-[#dbe7f4] bg-white p-8 shadow-lg text-center">
                <img
                    src={siteLogo}
                    alt="Logo"
                    className="mx-auto h-10 w-auto object-contain"
                />

                <div className="mt-6 flex justify-center">
                    <CheckCircle2 className="text-green-500" size={72} />
                </div>

                <h1 className="mt-4 text-2xl font-bold text-gray-900">
                    Payment Successful
                </h1>

                <p className="mt-2 text-sm text-gray-500">
                    Your transaction has been completed successfully.
                </p>

                {txnId && (
                    <p className="mt-3 text-xs text-gray-400">
                        Transaction ID: <span className="font-mono">{txnId}</span>
                    </p>
                )}

                <button
                    type="button"
                    onClick={() => navigate("/")}
                    className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1d4ed8] to-[#16a34a] py-3 text-sm font-semibold text-white transition hover:opacity-95 sm:text-base"
                >
                    <Home size={18} />
                    Go to Home
                </button>

                <p className="mt-4 text-xs text-gray-400">
                    Redirecting to home in{" "}
                    <span className="font-semibold text-gray-600">
                        {secondsLeft}
                    </span>
                    {secondsLeft === 1 ? " second" : " seconds"}...
                </p>
            </div>
        </div>
    );
}
